export default "__VITE_ASSET__ctAiIRLJ__"